import React, { Fragment } from "react";
import { Badge }  from "reactstrap";
import moment from 'moment'

import DefaultOfferImg from "~/assets/images/default-offer.png";
import SurveyImg from "~/assets/images/survey.png"
import WheelImg from "~/assets/images/dailyGoals/wheel-of-fortune.png";
import BetImg    from "~/assets/images/dailyGoals/lottery.png";

const TokensCard = ({item})=> {

  const source = {
    0 : {title: "Offer", icon: DefaultOfferImg},
    1 : {title: "Survey", icon: SurveyImg},
    2 : {title: "Spinning Wheel", icon: WheelImg},
    3 : {title: "Bet"           , icon: BetImg},
  };

  const type = {
    CLAIM   : 1,
    REVERSAL: 2
  };

  const formatDate = (date)=> moment(date).format("YYYY-MM-DD");

  return (
    <Fragment>
      <img src={source[item.source].icon} />

      <div className="item-details">
        <div>
          <h6> {source[item.source].title} </h6>
          <Badge color="points"> Tokens: {item.tokens} </Badge>
        </div>
        <div>
          <h6> {formatDate(item.createdAt)} </h6>
          {
            item.type === type.CLAIM
              ? <Badge color="custom-completed"> COMPLETED</Badge>
              : <Badge color="custom-reversal"> REVERSAL  </Badge>
          }
        </div>
      </div>
    </Fragment>
  );
};


export default TokensCard;
